module.exports = __webpack_public_path__ + "blzee.b4903f9dfd08d5dd703f.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/blzee/blzee.woff
// module id = ../../../../../src/assets/fonts/blzee/blzee.woff
// module chunks = styles